var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var OutputOrderSettingsModalController = /** @class */ (function (_super) {
            __extends(OutputOrderSettingsModalController, _super);
            function OutputOrderSettingsModalController($scope, model, workflowService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.scope = $scope;
                _this.scope.model = model;
                _this.scope.save = function () {
                    _this.validate();
                    if (_this.scope.validationMessages.length == 0) {
                        _this.dismissModal(true);
                    }
                };
                workflowService.getOutputOrder(model.workflowBlock.id).then(function (dto) {
                    _this.scope.model.dto = dto;
                });
                return _this;
            }
            OutputOrderSettingsModalController.prototype.validate = function () {
                this.scope.validationMessages = [];
                if (this.scope.model && this.scope.model.dto && this.scope.model.dto.toBlocks) {
                    if (Enumerable.from(this.scope.model.dto.toBlocks).any(function (i) { return i.order === undefined || i.order === null; })) {
                        this.scope.validationMessages.push("All destination workflow blocks must be given an output order");
                    }
                    var orderedToBlocks = Enumerable.from(this.scope.model.dto.toBlocks).orderBy(function (i) { return i.order; }).toArray();
                    for (var i = 0; i < orderedToBlocks.length; i++) {
                        if (orderedToBlocks[i].order !== i) {
                            this.scope.validationMessages.push("The destination workflow block must be sequential and begin with zero");
                            break;
                        }
                    }
                }
            };
            return OutputOrderSettingsModalController;
        }(controllers.BaseModalController));
        controllers.OutputOrderSettingsModalController = OutputOrderSettingsModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('OutputOrderSettingsModalController', ['$scope', 'model', 'workflowService', 'close']);
